import { render, staticRenderFns } from "./index.vue?vue&type=template&id=852c5580&scoped=true&"
import script from "./errorConfiguration.component.js?vue&type=script&lang=js&"
export * from "./errorConfiguration.component.js?vue&type=script&lang=js&"
import style0 from "./errorConfiguration.style.scss?vue&type=style&index=0&id=852c5580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852c5580",
  null
  
)

export default component.exports